import PlanType from './PlanType';

const UNLIMITED_ADSL = 'Unlimited ADSL';
const UNLIMITED_VDSL = 'Unlimited VDSL';
const ENABLE_200_NAME = 'Unlimited Fibre 200 Cantab';
const UNLIMITED_30_NAME = 'Unlimited Fibre 30';
const UNLIMITED_100_NAME = 'Unlimited Fibre 100';
const UNLIMITED_200_NAME = 'Unlimited Fibre 200';
const UNLIMITED_300_NAME = 'Unlimited Fibre 300';
const UNLIMITED_500_NAME = 'Unlimited Fibre 500';
const UNLIMITED_ULTRA_NAME = 'Unlimited Fibre Ultra';

const PlanDetails = {
  openTermLos: 'https://www.skinny.co.nz/skinny-terms/#UBB',
  fixedTermLos: 'https://www.skinny.co.nz/skinny-terms/#UBB',
  legalOfferSummaryLink: 'https://www.skinny.co.nz/skinny-terms/offer-summaries',
  plans: [
    {
      label: UNLIMITED_ADSL,
      description: 'Your basic broadband, great for general web browsing.​',
      type: PlanType.EUBA,
      download: {
        width: 13,
        description: '9Mbps Avg download',
        speed: 9,
        caveat: '',
        direction: 'download'
      },
      upload: {
        width: 5,
        description: '1Mbps Avg upload',
        speed: 1,
        caveat: '',
        direction: 'upload'
      }
    },
    {
      label: UNLIMITED_VDSL,
      description: 'A step up from basic broadband, great for general web browsing and watching video.',
      type: PlanType.WVS,
      download: {
        width: 42,
        description: '44Mbps Avg download',
        speed: 44,
        caveat: '',
        direction: 'download'
      },
      upload: {
        width: 20,
        description: '12Mbps Avg upload',
        speed: 12,
        caveat: '',
        direction: 'upload'
      }
    },
    {
      label: UNLIMITED_30_NAME,
      description: 'Our cheapest fibre plan. Great for all your fundamental basics like web browsing'
        + ' and video streaming.',
      type: PlanType.UFB,
      download: {
        width: 26,
        description: '30Mbps Avg download',
        speed: 30,
        caveat: '',
        direction: 'download'
      },
      upload: {
        width: 20,
        description: '10Mbps Avg upload',
        speed: 10,
        caveat: '',
        direction: 'upload'
      }
    },
    {
      label: UNLIMITED_100_NAME,
      description: 'Great for big downloads and binging your favourite TV show.',
      type: PlanType.UFB,
      download: {
        width: 26,
        description: '100Mbps Avg download',
        speed: 100,
        caveat: '',
        direction: 'download'
      },
      upload: {
        width: 20,
        description: '20Mbps Avg upload',
        speed: 20,
        caveat: '',
        direction: 'upload'
      }
    },
    {
      label: UNLIMITED_200_NAME,
      description: 'A good option for those big households where everyone likes to browse their own way without'
        + ' worrying about buffering.',
      type: PlanType.UFB,
      download: {
        width: 46,
        description: '200Mbps Avg download',
        speed: 200,
        caveat: '',
        direction: 'download'
      },
      upload: {
        width: 20,
        description: '20Mbps Avg upload',
        speed: 20,
        caveat: '',
        direction: 'upload'
      }
    },
    {
      label: UNLIMITED_300_NAME,
      description: 'A good option for those big households where everyone likes to browse their own way without'
        + ' worrying about buffering.',
      type: PlanType.UFB,
      download: {
        width: 46,
        description: '300Mbps Avg download',
        speed: 500,
        caveat: '',
        direction: 'download'
      },
      upload: {
        width: 20,
        description: '100Mbps Avg upload',
        speed: 100,
        caveat: '',
        direction: 'upload'
      }
    },
    {
      label: UNLIMITED_500_NAME,
      description: 'A good option for those big households where everyone likes to browse their own way without'
        + ' worrying about buffering.',
      type: PlanType.UFB,
      download: {
        width: 46,
        description: '300Mbps Avg download',
        speed: 500,
        caveat: '',
        direction: 'download'
      },
      upload: {
        width: 20,
        description: '100Mbps Avg upload',
        speed: 100,
        caveat: '',
        direction: 'upload'
      }
    },
    {
      label: ENABLE_200_NAME,
      description: 'We\'re all about keeping prices low and customers happy, so we\'re offering a special deal to the '
        + 'people of Canterbury. Enjoy fast broadband at a great price. Offer only avaliable at compatible Canterbury '
        + 'addresses.',
      type: PlanType.UFB,
      download: {
        width: 90,
        description: '200Mbps Avg download',
        speed: 200,
        caveat: '',
        direction: 'download'
      },
      upload: {
        width: 50,
        description: '20Mbps Avg upload',
        speed: 20,
        caveat: '',
        direction: 'upload'
      }
    },
    {
      label: UNLIMITED_ULTRA_NAME,
      description: 'For those who are super serious about their broadband connection. If you’re into gaming or are'
        + ' super data hungry, this is the speed for you.',
      type: PlanType.UFB,
      download: {
        width: 90,
        description: '855Mbps Avg download',
        speed: 855,
        caveat: '',
        direction: 'download'
      },
      upload: {
        width: 50,
        description: '501Mbps Avg upload',
        speed: 501,
        caveat: '',
        direction: 'upload'
      }
    }
  ]
};

export default PlanDetails;



/** WEBPACK FOOTER **
 ** ./src/common/PlanDetails.js
 **/